// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconSelectorModal_iconContainer__PhSOa","container":"IconSelectorModal_container__IweDl","selected":"IconSelectorModal_selected__w-ps4"};